var _defs, _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1Aroha3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2,.cls-3{fill:#fff;}.cls-2,.cls-3,.cls-4{stroke:#000;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3,.cls-4{stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.78,
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.56,264.45a38.46,38.46,0,0,1-10.95,10.39,6.07,6.07,0,0,1-3.34,1.2,8.57,8.57,0,0,1-3.11-1.12c-1.77-.84-3.91-1.3-5.65-.41a4.77,4.77,0,0,0-2.42,4.53,6.46,6.46,0,0,0,2.61,4.58,10.21,10.21,0,0,0,5,1.89,18.36,18.36,0,0,0,8.6-1.27,40.43,40.43,0,0,0,7.71-4.16,26.34,26.34,0,0,0,5-4,10.63,10.63,0,0,0,2.89-5.6,6.27,6.27,0,0,0-1.51-5.24C145.1,263.94,142.49,263.14,141.56,264.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.41,274.69a27.13,27.13,0,0,0,8.13-19.25,24.12,24.12,0,0,0-8.6-18.77c-.46-.32-.93-.65-1.38-1A48.58,48.58,0,0,0,136.2,234a2.78,2.78,0,0,0-2,.32c-1,.76-.81,2.42-.08,3.41,6.77,9.1,7.43,27.09,7.5,27.13C145.55,267.07,146.77,272.12,146.41,274.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.26,211.73a6.2,6.2,0,0,0-4.37,2.7,3.49,3.49,0,0,0-.66,2.24,3,3,0,0,0,1.74,2.25,4.94,4.94,0,0,0,2.9.3v-.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.11,235.33a6.17,6.17,0,0,0,.18,4.95,3.94,3.94,0,0,0,4.27,2.06,4.14,4.14,0,0,0,2.71-2.9,7.19,7.19,0,0,0-.13-4.08v0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 140.56,
    cy: 216.69,
    r: 19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.56,214.39c10.74,4.4,24.1,2,32.45-10.87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.62,214c-.44,7.58,2.34,13.79,7.46,19.38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.87,235.69c1.42-2.74,2.57-3,5.33-4.61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.69,230.25a6,6,0,0,1,1.87-.8,2,2,0,0,1,1.88.53,1.48,1.48,0,0,1,0,1.94,2.81,2.81,0,0,1-1.48.49c-.51.11-1.09.46-1.09,1a1.85,1.85,0,0,0,.45,1,5,5,0,0,1,.07,5.34,4.27,4.27,0,0,1-4.71,1.81,6,6,0,0,1-3-2.35,8.1,8.1,0,0,1-1.39-6.87,5.31,5.31,0,0,1,5.36-3.84C102.8,229.36,103.68,230.52,103.69,230.25Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.65,
    cy: 218.9,
    rx: 1.9,
    ry: 1.72,
    transform: "translate(-117.4 154.39) rotate(-45)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.73,
    cy: 230.74,
    rx: 1.9,
    ry: 1.72,
    transform: "translate(-123.11 164.28) rotate(-45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.33,248.3a13.83,13.83,0,0,1-1.74,9.65c-1.16,2-3.56,3.79-5.23,5.36-1.51,1.41-2.38,5.92-7.17,6.31-2.06.17-5.49-.44-5.79-3.38-.23-2.18,1.9-3.83,3.71-5.06-.88-.2-2.64-1.23-2-2.27,1.12-1.73,3.73-.18,5.1.54.2.22,4.35-1,6-4.29a9.64,9.64,0,0,0,.77-7.85A5.47,5.47,0,0,1,146.33,248.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1Aroha3);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Aroha_3.71c46bb1b557f1872882daf5c29ac835.svg";
export { ForwardRef as ReactComponent };